import React from 'react';
import * as PropTypes from 'prop-types';
import BaseNurseAutocomplete from '../../base/autocomplete/specialized/BaseNurseAutocomplete';
import { useFieldFast } from '../../../hooks';

const NurseAutocomplete = ({ name, label, disabled, fullWidth, onChange }) => {
    const [{ value }, { error }, { setValue }] = useFieldFast(name);

    const handleChange = (event, newValue) => {
        setValue(newValue ? newValue.id : newValue);
        if (onChange) onChange(event, newValue ? newValue.id : newValue);
    };

    return (
        <BaseNurseAutocomplete
            name={name}
            label={label}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            fullWidth={fullWidth}
            error={error}
        />
    );
};

NurseAutocomplete.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    onChange: PropTypes.func,
};

NurseAutocomplete.defaultProps = {
    label: null,
    disabled: false,
    fullWidth: false,
    onChange: null,
};

export default NurseAutocomplete;
